import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { Link, useNavigate,useLocation,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/ScoutMyAccount.css';
import ScoutSidebar from './ScoutSidebar';

const scoutAccount = {
    smwwMail:"",
    name:"Testdhanap Test",
    personalMail:"testdhanapnew@preferati.net",
    publicProfile: "https://www.smwwscout.com/scout/testdhanap-test",
}

const MyScoutAccount = () => {

    const [isLoading, setIsLoading] = useState(true); 
    const [scoutAccount, setScoutAccount] = useState({});

    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    var {uid} = useParams();

    useEffect(() => {
            Promise.all([
                getscoutaccountdetails()
            ])
            .then(() => {
            
                setIsLoading(false);
            })
            
        },[]);
        async function getscoutaccountdetails() {
        
           
                const response = await fetch(
                     app_url+'smwwscout/getscoutaccountdetails?uid='+loggedin_uid,
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                    setScoutAccount(responsedata.data.result);
                }
           
        }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>My Account</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="page-view-myorder">
                            <div className="panel panel-default">
                                <div className="panel-heading" style={{background:"#fefefe"}}>
                                    <h1 style={{marginTop:"0px", marginBottom: "20px"}}>{scoutAccount.name}</h1>
                                </div>
                            
                                <div className="panel-body scout-my-account-body">
                                    <p>Your SMWW mail alias is: <b>{scoutAccount.smwwMail}</b></p>
                                    <p>This is the email address shown on the SMWWScout.com site.</p>
                                    <p>Which directs mail to your personal email of: <b>{scoutAccount.personalMail}</b></p>
                                    <p>The link to your public profile page is:</p>
                                    <p>
                                        <b><a href={scoutAccount.publicProfile} target="_blank" style={{overflowWrap:"break-word"}}>{scoutAccount.publicProfile}</a></b>
                                    </p>
                                    <p>To renew your membership,  <a href={scoutAccount.cart_link} target="">click here</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <ScoutSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default MyScoutAccount;